import { Input, 
    NumberDecrementStepper,
     NumberIncrementStepper, 
     NumberInput, 
     NumberInputField, 
     NumberInputStepper, 
     Text,
     Select,
     HStack,
     Badge
} from '@chakra-ui/react';
import DatePicker from '../ui/DatePicker';
import { useDispatch, useSelector } from 'react-redux';
import saveForm from '../../redux/actions/bankForms';
import { AppDispatch } from '../../redux/storage';


const MercantilPaymentForm = () => {

    const dispatch = useDispatch<AppDispatch>();
    const { reference, amount, date, customerId, customerIdType, issuingBank } = useSelector((state: any) => state.paymentForm);
    const paymentResponse = useSelector((states: any) => states.verifyPayment)

    const handleChange = (event: { target: HTMLInputElement | HTMLSelectElement }) => {

        const { name, value } = event.target

        dispatch(saveForm(name, value))
    }

    const handleDatePicker = (e: any) => {
        
        dispatch(saveForm('date', e))
    }

    const handleAmount = (e: any) => {
        dispatch(saveForm('amount', e))
    }

    return (
        <>
            <Text mb='8px' mt={2}>Referencia</Text>
            <Input placeholder='Referencia' name="reference" value={reference} onChange={handleChange} />
            <Badge variant="solid">
                Solo debe tomar en cuenta los últimos 8 números
            </Badge>

            <Text mb='8px' mt={2}>Identificación emisor</Text>

            <HStack spacing={1} mt={5} mb={5} w='100%'>
                <Select variant='filled' name="customerIdType" value={customerIdType} onChange={handleChange}>
                    <option value='J' key={0}>J-</option>
                    <option value='V' key={1}>V-</option>
                </Select>

                <Input placeholder='Identificación emisor' name="customerId" value={customerId} onChange={handleChange} />
            </HStack>
           
            <Text mb='8px' mt={2}>Banco emisor</Text>

            <Select variant='filled' name="issuingBank" onChange={handleChange} value={issuingBank}>
                <option value='' key={0}>-- Seleccionar --</option>
                {
                    paymentResponse.fetchInitialData.bank.map((banks: any) => <option value={banks.code} key={banks.code}>{banks.name}</option>)
                }
            </Select>

            <Text mb='8px' mt={2}>Monto pagado</Text>
            <NumberInput name="amount" precision={2} value={amount} onChange={handleAmount}>
            <NumberInputField />
                <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                </NumberInputStepper>
            </NumberInput>
            <DatePicker
                onChange={handleDatePicker}
                selectedDate={date}
                text="Fecha del Pago"
                name="datepicker"
            />
        </>
    );
}


export default MercantilPaymentForm;
